/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PriorityRequestFormFilter,
  PriorityRequestReachabilityFilter,
  PriorityRequestResponse,
  ProblemDetails,
} from '../models/index';
import {
    PriorityRequestFormFilterFromJSON,
    PriorityRequestFormFilterToJSON,
    PriorityRequestReachabilityFilterFromJSON,
    PriorityRequestReachabilityFilterToJSON,
    PriorityRequestResponseFromJSON,
    PriorityRequestResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DeletePriorityRequestRequest {
    clientId: string;
}

export interface GetAllPriorityRequestsRequest {
    counselorId?: string;
    reachability?: PriorityRequestReachabilityFilter;
    form?: PriorityRequestFormFilter;
}

export interface PullPriorityRequestForwardRequest {
    clientId: string;
}

export interface RecordPriorityRequestContactAttemptRequest {
    clientId: string;
}

/**
 * PriorityRequestsApi - interface
 * 
 * @export
 * @interface PriorityRequestsApiInterface
 */
export interface PriorityRequestsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorityRequestsApiInterface
     */
    deletePriorityRequestRaw(requestParameters: DeletePriorityRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deletePriorityRequest(requestParameters: DeletePriorityRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} [counselorId] 
     * @param {PriorityRequestReachabilityFilter} [reachability] 
     * @param {PriorityRequestFormFilter} [form] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorityRequestsApiInterface
     */
    getAllPriorityRequestsRaw(requestParameters: GetAllPriorityRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriorityRequestResponse>>>;

    /**
     */
    getAllPriorityRequests(requestParameters: GetAllPriorityRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriorityRequestResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorityRequestsApiInterface
     */
    pullPriorityRequestForwardRaw(requestParameters: PullPriorityRequestForwardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    pullPriorityRequestForward(requestParameters: PullPriorityRequestForwardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorityRequestsApiInterface
     */
    recordPriorityRequestContactAttemptRaw(requestParameters: RecordPriorityRequestContactAttemptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    recordPriorityRequestContactAttempt(requestParameters: RecordPriorityRequestContactAttemptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PriorityRequestsApi extends runtime.BaseAPI implements PriorityRequestsApiInterface {

    /**
     */
    async deletePriorityRequestRaw(requestParameters: DeletePriorityRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deletePriorityRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priority-requests/{clientId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePriorityRequest(requestParameters: DeletePriorityRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePriorityRequestRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllPriorityRequestsRaw(requestParameters: GetAllPriorityRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriorityRequestResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['counselorId'] != null) {
            queryParameters['CounselorId'] = requestParameters['counselorId'];
        }

        if (requestParameters['reachability'] != null) {
            queryParameters['Reachability'] = requestParameters['reachability'];
        }

        if (requestParameters['form'] != null) {
            queryParameters['Form'] = requestParameters['form'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priority-requests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriorityRequestResponseFromJSON));
    }

    /**
     */
    async getAllPriorityRequests(requestParameters: GetAllPriorityRequestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriorityRequestResponse>> {
        const response = await this.getAllPriorityRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async pullPriorityRequestForwardRaw(requestParameters: PullPriorityRequestForwardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling pullPriorityRequestForward().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priority-requests/{clientId}/pull-forward`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pullPriorityRequestForward(requestParameters: PullPriorityRequestForwardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pullPriorityRequestForwardRaw(requestParameters, initOverrides);
    }

    /**
     */
    async recordPriorityRequestContactAttemptRaw(requestParameters: RecordPriorityRequestContactAttemptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling recordPriorityRequestContactAttempt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/priority-requests/{clientId}/contact-attempts`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async recordPriorityRequestContactAttempt(requestParameters: RecordPriorityRequestContactAttemptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.recordPriorityRequestContactAttemptRaw(requestParameters, initOverrides);
    }

}
